import { DataGridPro, DataGridProProps } from "@mui/x-data-grid-pro";
import { styled } from "@mui/material/styles";

const DataGridUI = styled(DataGridPro)<DataGridProProps>(
  ({ theme }) => ({
    // New row highlighting
    "& .super-app-theme--New": {
      backgroundColor: theme.palette.mode === 'dark' ? 'rgba(250, 250, 250, 0.08)' : 'rgba(35, 35, 35, 0.04)',
      "&:hover": {
        backgroundColor: theme.palette.mode === 'dark' ? 'rgba(250, 250, 250, 0.12)!important' : 'rgba(35, 35, 35, 0.08)!important',
      },
    },
    
    // Column Headers
    "& .MuiDataGrid-columnHeaders": {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText,
      borderBottom: `1px solid ${theme.palette.divider}`,
    },
    
    // Checkbox in headers
    "& .MuiDataGrid-columnHeader .MuiCheckbox-root svg": {
      color: theme.palette.primary.contrastText,
    },
    
    // Menu icon in headers
    "& .MuiDataGrid-menuIconButton": {
      color: theme.palette.primary.contrastText,
    },
    
    // Sort icon
    "& .MuiDataGrid-columnHeaderTitleContainer .MuiDataGrid-sortIcon": {
      color: theme.palette.primary.contrastText,
    },

    // Pinned columns
    "& .MuiDataGrid-pinnedColumns--left .MuiDataGrid-columnHeaders": {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.text.primary,
    },
    
    // Row hover effect
    "& .MuiDataGrid-row:hover": {
      backgroundColor: theme.palette.action.hover,
    },
    
    // Cell borders and styling
    "& .MuiDataGrid-cell": {
      borderBottom: `1px solid ${theme.palette.divider}`,
      color: theme.palette.text.primary,
      outline: "none !important",
      "&:focus": {
        outline: "none !important",
      },
      "&:focus-visible": {
        outline: "none !important",
      },
      "&:focus-within": {
        outline: "none !important",
      },
    },
    
    // Grid background
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.primary,
    
    // Footer
    "& .MuiDataGrid-footerContainer": {
      backgroundColor: theme.palette.background.paper,
      borderTop: `1px solid ${theme.palette.divider}`,
    },

    // Remove ALL focus borders and outlines from the entire DataGrid
    "&:focus": {
      outline: "none !important",
      border: "none !important",
      boxShadow: "none !important",
    },
    "&:focus-visible": {
      outline: "none !important",
      border: "none !important",
      boxShadow: "none !important",
    },
    "&:focus-within": {
      outline: "none !important",
      border: "none !important",
      boxShadow: "none !important",
    },
    
    // Remove focus from the root grid element
    "& .MuiDataGrid-root": {
      outline: "none !important",
      border: "none !important",
      boxShadow: "none !important",
    },
    "& .MuiDataGrid-root:focus": {
      outline: "none !important",
      border: "none !important",
      boxShadow: "none !important",
    },
    "& .MuiDataGrid-root:focus-visible": {
      outline: "none !important",
      border: "none !important",
      boxShadow: "none !important",
    },
    "& .MuiDataGrid-root:focus-within": {
      outline: "none !important",
      border: "none !important",
      boxShadow: "none !important",
    },
    
    // Remove focus from the main grid container
    "& .MuiDataGrid-main": {
      outline: "none !important",
      border: "none !important",
      boxShadow: "none !important",
    },
    "& .MuiDataGrid-main:focus": {
      outline: "none !important",
      border: "none !important",
      boxShadow: "none !important",
    },
    "& .MuiDataGrid-main:focus-visible": {
      outline: "none !important",
      border: "none !important",
      boxShadow: "none !important",
    },
    
    // Remove focus from column headers
    "& .MuiDataGrid-columnHeader": {
      outline: "none !important",
      border: "none !important",
      boxShadow: "none !important",
    },
    "& .MuiDataGrid-columnHeader:focus": {
      outline: "none !important",
      border: "none !important",
      boxShadow: "none !important",
    },
    "& .MuiDataGrid-columnHeader:focus-visible": {
      outline: "none !important",
      border: "none !important",
      boxShadow: "none !important",
    },
    "& .MuiDataGrid-columnHeader:focus-within": {
      outline: "none !important",
      border: "none !important",
      boxShadow: "none !important",
    },
    
    // Remove focus from rows
    "& .MuiDataGrid-row": {
      outline: "none !important",
      border: "none !important",
      boxShadow: "none !important",
    },
    "& .MuiDataGrid-row:focus": {
      outline: "none !important",
      border: "none !important",
      boxShadow: "none !important",
    },
    "& .MuiDataGrid-row:focus-visible": {
      outline: "none !important",
      border: "none !important",
      boxShadow: "none !important",
    },
    "& .MuiDataGrid-row:focus-within": {
      outline: "none !important",
      border: "none !important",
      boxShadow: "none !important",
    },
    
    // Remove focus from virtual scroller
    "& .MuiDataGrid-virtualScroller": {
      outline: "none !important",
      border: "none !important",
      boxShadow: "none !important",
    },
    "& .MuiDataGrid-virtualScroller:focus": {
      outline: "none !important",
      border: "none !important",
      boxShadow: "none !important",
    },
    "& .MuiDataGrid-virtualScroller:focus-visible": {
      outline: "none !important",
      border: "none !important",
      boxShadow: "none !important",
    },
    
    // Remove focus from any other grid elements
    "& *:focus": {
      outline: "none !important",
      border: "none !important",
      boxShadow: "none !important",
    },
    "& *:focus-visible": {
      outline: "none !important",
      border: "none !important",
      boxShadow: "none !important",
    },
    "& *:focus-within": {
      outline: "none !important",
      border: "none !important",
      boxShadow: "none !important",
    },
  })
);

export default DataGridUI;
